// components/Ticker.js
import React from "react";
import styles from "./Ticker.module.css";

const Ticker = () => {
  return (
    <div className={styles.tickerWrapper}>
      <p className="text-white text-2xl  font-semibold uppercase stroke-current">
        From intimate boardroom sessions to grand international conferences, we
        handle every detail with precision and flair.
      </p>
    </div>
  );
};

export default Ticker;
